function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTon = function SvgTon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M28 56c15.5 0 28-12.5 28-28S43.5 0 28 0 0 12.5 0 28s12.5 28 28 28",
    style: {
      fill: "#0098ea"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6 15.6H18.4c-3.5 0-5.7 3.8-4 6.9L26.2 43c.8 1.3 2.7 1.3 3.5 0l11.8-20.5c1.8-3.1-.4-6.9-3.9-6.9M26.3 36.8l-2.6-5-6.2-11.1c-.4-.7.1-1.6 1-1.6h7.8zm12.2-16.1-6.2 11.1-2.6 5V19.1h7.8c.9 0 1.4.9 1 1.6",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgTon;